// extracted by mini-css-extract-plugin
export default {"submitButton":"passwordValidation_submitButton__2X8A5","info":"passwordValidation_info__H2uW3"};